import {registerGraph, mergeGraph} from '@/angular/modules/vrm-graph/config-utils';

registerGraph('advancedGraph', advancedGraph);

/* @ngInject */
function advancedGraph(GraphService, defaultGraph) {
    const GraphColors = GraphService.colors;
    return mergeGraph(defaultGraph(), {
        options: {
            colors: [GraphColors.blue, GraphColors.orange, GraphColors.black, GraphColors.green],
            plotOptions: {
                series: {
                    marker: {
                        enabled: false
                    },
                    fillOpacity: 0.3
                },
            },
            chart: {
                marginTop: 10,
                marginLeft: 60,
                marginRight: 60,
                // Has effect through graph-widget/zoomstate.js
                hideZoomButton: false,
            },
            tooltip: GraphService.getTooltipFormatterForGraphWidget(),
        },
        xAxis: {
            type: 'datetime',
            labels: {formatter: GraphService.datetimeLabeler()},
            minorTickInterval: 'auto',
            crosshair: {
                width: 1
            },
            events: {
                setExtremes: GraphService.highcharts.syncExtremes
            },
            minorGridLineWidth: 0,
            lineWidth: 0, // Disable the black line at the bottom xAxis
        },
        yAxis: [
            {
                title: { text: null },
                labels: {
                    align: 'center',
                    style: { color: GraphColors.blue },
                    formatter: function () {
                        const tickPositions = this.axis.tickPositions;
                        const maxDecimals = tickPositions.reduce((max, pos) => {
                            const decimals = (pos.toString().split('.')[1] || '').length;
                            return Math.max(max, decimals);
                        }, 0);
                        return Number(this.value).toFixed(maxDecimals);
                    }
                }
            },
            {
                title: { text: null },
                labels: {
                    align: 'center',
                    style: { color: GraphColors.orange },
                    formatter: function () {
                        const hasDecimals = this.axis.tickPositions.some(pos => !Number.isInteger(pos));
                        return hasDecimals ? this.value.toFixed(2) : this.value;
                    }
                },
                opposite: true
            },
            {
                title: { text: null },
                labels: {
                    align: 'center',
                    style: { color: GraphColors.black },
                    formatter: function () {
                        const hasDecimals = this.axis.tickPositions.some(pos => !Number.isInteger(pos));
                        return hasDecimals ? this.value.toFixed(2) : this.value;
                    }
                },
                opposite: true
            }
        ],
        size: {
            height: null
        },
        series: []
    });
}
